<div class="item" (click)="click()" (keydown.enter)="click()" (keydown.space)="click()" 
    [ngClass]="{'clicked': tile.clicked, 'dead':dead, 'number':tile.value!=='' && tile.value!=='*'}">
    <ng-container *ngIf="tile.clicked || tile.disabled">
        {{tile.value}}
    </ng-container>
    <ng-container *ngIf="!tile.clicked && !tile.disabled">
        &nbsp;
    </ng-container>
</div>
